<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fas fa-person-carry mr-4"></i>Operative Bookings Needing Actioning</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="loaded" class="flex flex-col text-gray-500 cursor-pointer" @click="go">
                <div class="w-full text-center text-5xl hover:text-brand" v-if="count">
                    <div v-text="count"></div>
                    <div class="text-lg">{{ operatives }} operative{{operatives>1?'s':''}} across {{ dates }} date{{dates>1?'s':''}}</div>
                </div>
                <div class="place-content-center w-full" v-else>
                    <div class="flex flex-col text-gray-500">
                        <div class="w-full text-center font-bold text-md"><span><i
                            class="text-lg text-green-600 far fa-check mr-4"></i></span>No Bookings need actioning
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {OperativePlanning} from "@models";
import moment from "moment";

export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            loaded: false,
            count: 0,
            operatives: 0,
            dates: 0,
        }
    },
    computed: {},
    methods: {
        go(){
            window.document.location = route('mobile.packages.operative-planning',[this.dashboardProps.legacyPackage.id])+'?filter=needs_actioning'
        }
    },
    async mounted() {
        let bookings = await OperativePlanning.all(this.dashboardProps.legacyPackage.id, 'requires_booking_confirmation')
        let dates = []
        let operatives = []
        let total = 0;
        bookings.filter((i) => moment(i.date).isBefore(moment())).forEach((i) => {
            i.bookings.forEach((i2) => {
                if (i2.pending_confirmation) {
                    if (!dates.includes(i.date)) {
                        dates.push(i.date);
                    }
                    if (!operatives.includes(i2.id)) {
                        operatives.push(i2.id)
                    }
                    total ++;
                }
            })
        })
        this.count = total;
        this.dates = dates.length;
        this.operatives = operatives.length;
        this.loaded = true;
    }
}

</script>